import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
} from "@mui/material";
import ListIcon from "@mui/icons-material/List";
import FolderIcon from "@mui/icons-material/Folder";
import HomeIcon from "@mui/icons-material/Home";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAcl from "../../hooks/useAcl";

const drawerWidth = 240;

const DesktopDrawer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { canRead: canReadProjects } = useAcl("Project");

  const menuItems = [
    { key: "home", icon: <HomeIcon />, route: "/" },
    { key: "tasks", icon: <ListIcon />, route: "/tasks" },
    ...(canReadProjects !== false
      ? [{ key: "projects", icon: <FolderIcon />, route: "/projects" }]
      : []),
    { key: "calendar", icon: <CalendarTodayIcon />, route: "/calendar" },
    { key: "profile", icon: <AccountCircleIcon />, route: "/profile" },
  ];

  const isActive = (route: string, pathname: string): boolean => {
    if (route === "/") {
      return pathname === "/";
    }
    if (route === "/tasks") {
      return pathname.startsWith("/tasks") || pathname.startsWith("/task/");
    }
    if (route === "/projects") {
      return pathname.startsWith("/projects") || pathname.startsWith("/project/");
    }
    return pathname.startsWith(route);
  };

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#E0E6F1",
        },
      }}
    >
      <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/LogoPWA.svg`}
          alt={t("logoAlt")}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>

      <List>
        {menuItems.map((item) => {
          const active = isActive(item.route, location.pathname);
          return (
            <ListItem key={item.key} disablePadding>
              <ListItemButton
                onClick={() => {
                  if (!active) {
                    navigate(item.route);
                  }
                }}
                selected={active}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: "#D0DDEE",
                    "&:hover": {
                      backgroundColor: "#D0DDEE",
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    color: active ? "#222" : "inherit",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={t(`menu.${item.key}`)}
                  primaryTypographyProps={{
                    fontWeight: active ? 600 : 400,
                    color: active ? "#222" : "inherit",
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
};

export default DesktopDrawer;
